<ng-container *transloco="let t">
  <ld-base-modal
    [title]="t('modalsSwitchBorrowerTitle')"
    [size]="'medium'"
    [ariaLabelledBy]="'switch-borrower-modal-title'"
    (closeModal)="onCancel()"
  >
    <div modal-content>
      <p class="font-dm text-sm text-ld-neutral-600 mb-4">{{ t('modalsSwitchBorrowerSelectPrompt') }}</p>

      <div class="space-y-3">
        @for (borrower of borrowers(); track borrower.id) {
          <button
            [id]="'borrower-option-' + borrower.id"
            type="button"
            class="w-full p-4 text-left border rounded-xl transition-all cursor-pointer"
            [class.border-ld-primary]="isSelected(borrower)"
            [class.bg-ld-primary-50]="isSelected(borrower)"
            [class.border-ld-border]="!isSelected(borrower)"
            [class.hover:border-ld-primary-200]="!isSelected(borrower)"
            (click)="onSelectBorrower(borrower)"
          >
            <div class="flex items-center gap-3">
              <div class="size-10 rounded-full bg-ld-neutral-100 flex items-center justify-center">
                <mat-icon class="text-ld-neutral-600">person</mat-icon>
              </div>
              <div class="flex-1">
                <p class="font-dm font-medium text-ld-neutral">
                  {{ getBorrowerDisplayName(borrower) }}
                </p>
                @if (isCurrentBorrower(borrower)) {
                  <span class="text-xs font-dm text-ld-primary">{{ t('modalsSwitchBorrowerCurrentLabel') }}</span>
                }
              </div>
              @if (isSelected(borrower)) {
                <mat-icon class="text-ld-primary">check_circle</mat-icon>
              }
            </div>
          </button>
        }
      </div>
    </div>

    <div modal-footer>
      <button id="switch-borrower-cancel-btn" type="button" class="btn-outline-ld-purple" (click)="onCancel()">
        {{ t('commonButtonsCancel') }}
      </button>
      <button
        id="switch-borrower-confirm-btn"
        type="button"
        class="btn-primary-ld-purple"
        [disabled]="!selectedBorrower()"
        (click)="onConfirm()"
      >
        {{ t('modalsSwitchBorrowerSwitchButton') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
